<template>
  <div class="full-item flex flex-direction align-center">
    <el-form
      ref="organizationForm"
      :model="User.organization_info"
      :rules="organizationRules"
      :label-position="UI.isMobile ? 'top' : 'left'"
      :label-width="UI.isMobile ? undefined : '80px'"
      style="width: 90%;"
    >
      <el-form-item label="单位名称" prop="organization">
        <el-input
          placeholder="请输入单位名称"
          clearable
          v-model="User.organization_info.organization"
        ></el-input>
      </el-form-item>
      <el-form-item label="单位地址" prop="address">
        <el-input
          placeholder="请输入单位地址"
          clearable
          v-model="User.organization_info.address"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contact">
        <el-input
          placeholder="请输入联系人"
          clearable
          v-model="User.organization_info.contact"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系座机" prop="contact_phone">
        <el-input
          placeholder="请输入联系座机"
          clearable
          v-model="User.organization_info.contact_phone"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系手机" prop="contact_mobile">
        <el-input
          placeholder="请输入联系手机"
          clearable
          v-model="User.organization_info.contact_mobile"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input
          placeholder="请输入邮箱"
          clearable
          v-model="User.organization_info.email"
        ></el-input>
      </el-form-item>
      <el-form-item :label="'认证材料'" prop="auth_file">
        <MediaUpload
          ref="upload"
          :action="uploadUrl + '/upload/organization'"
          :suffixList="['.png', '.pdf', '.jpg']"
          :file="User.organization_info.auth_file"
          @success="handlerUploadSuccess()"
        ></MediaUpload>
      </el-form-item>
    </el-form>

    <el-button
      class="login-button padding-xs margin-top"
      type="primary"
      size="mini"
      @click="submit()"
    >
      提交审核
    </el-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mobileRegex, emailRegex } from '@/utils/reConsts.js';
import MediaUpload from '@/components/upload/mediaUpload.vue';
import { baseUrl } from '@/utils/consts.js';
import { showErrorMsg, showSuccessMsg } from '@/utils/uiUtils.js';
import { submitOrganization } from '@/servers/user.js';
import pdf from '@/components/pdfShow.vue';

export default {
  components: {
    pdf,
    MediaUpload,
  },

  data() {
    let validateMobile = (_, value, callback) => {
      if (!mobileRegex.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

    let validateEmail = (_, value, callback) => {
      if (!emailRegex.test(value)) {
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
    };

    return {
      uploadUrl: baseUrl,
      organizationRules: {
        organization: [
          {
            required: true,
            message: '请输入单位名称',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请输入单位地址',
            trigger: 'blur',
          },
        ],
        contact: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        contact_phone: [
          {
            required: true,
            message: '请输入联系座机',
            trigger: 'blur',
          },
        ],
        contact_mobile: [
          {
            required: true,
            message: '请输入联系手机',
            trigger: 'blur',
          },
          {
            validator: validateMobile,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur',
          },
          {
            validator: emailRegex,
            trigger: 'blur',
          },
        ],
        auth_file: [
          {
            required: true,
            message: '请上传材料',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  methods: {
    ...mapMutations(['getUserState']),

    handlerUploadSuccess: function() {
      this.User.organization_info.auth_file = this.$refs.upload.uploadRes;
    },

    submit: function() {
      let that = this;
      this.$refs.organizationForm.validate((valid) => {
        if (valid) {
          submitOrganization(this.User.organization_info, function(res) {
            showSuccessMsg(res);
            that.getUserState();
            that.$router.replace({
              name: 'info',
            });
          });
        } else {
          showErrorMsg('请检查输入的参数.');
        }
      });
    },
  },
};
</script>
<style scoped>
.login-button {
  width: 200px;
}

.verify-bar-area {
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/organizationApprove/organization.vue